import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import en from "../../language/En";
import ar from "../../language/Ar";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { API_PATH } from "../../api/apiPath";
import { putApi } from "../../api/axiosInstance";
import { fetchAdminProfile } from "../../redux/adminReducer";
import Loader from "../../common/loader";
import { toast } from "react-toastify";

function AdminProfile() {
  const { translations } = useSelector((state) => state.language);
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const profile = useSelector((state) => state.admin?.admin?.profile);

  useEffect(() => {
    dispatch(fetchAdminProfile());
  }, [dispatch]);

  useEffect(() => {
    if (profile) {
      setFirstName(profile.name || "");
      setEmail(profile.email || "");
      setPhoneNumber(profile.fullPhoneNumber || "");
    }
  }, [profile]);

  const onSubmit = async () => {
    setLoading(true);
    try {
      const res = await putApi(API_PATH.ADMIN.UPDATE_PROFILE, {
        name: firstName,
        email: email,
        fullPhoneNumber: phoneNumber,
      });

      if (res.status) {
        toast.success(translations.toaster.profileupdatedsuccessfully);
        // You can optionally update local user state here
        dispatch(fetchAdminProfile());
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      toast.error(translations.toaster.failedtoupdateprofile);
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordUpdate = async () => {
    if (newPassword !== confirmPassword) {
      toast.error(translations.toaster.newpasswordandconfirmpassworddonotmatch);
      return;
    }

    setLoading(true);
    try {
      const res = await putApi(API_PATH.ADMIN.CHANGE_PASSWORD, {
        currentPassword,
        newPassword,
        confirmPassword,
      });

      if (res.status) {
        toast.success(translations.toaster.passwordupdatedsuccessfully);
        setCurrentPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        toast.error(res.message || translations.toaster.failedtoupdatepassword);
      }
    } catch (error) {
      console.error("Error updating password:", error.response?.data || error);
      toast.error(
        error.response?.data?.message ||
          translations.toaster.Failedtoupdatepassword
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      {/*  <div className="min-h-screen w-full px-4 py-4">
        <section className="pt-1 grid grid-cols-2 items-center">
          <h1 className="text-xl font-bold text-white">
            {texts.settings}
          </h1>
          <div className="text-md text-white flex items-center justify-end space-x-1 ">
            <div className="rounded-full bg-[#5A189A] py-2 px-3">
              <Link to="/" className="text-white no-underline cursor-pointer">
                {texts.dashboard}
              </Link>
              <span className="mx-1">/</span>
              <span className="text-gray-500">{texts.settings}</span>
            </div>
          </div>
        </section>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
  {/* Personal Information 
  <div className="bg-gray-800 shadow-xl rounded p-6 text-white">
    <h2 className="text-lg font-semibold mb-4 border-b border-gray-600 pb-4">{texts.personalInformation}</h2>
    <div className="space-y-4">
        <div>
        <label>{texts.firstName}</label>
        <input placeholder={texts.firstName} className="bg-gray-900 w-full px-4 py-2 mt-1 rounded" />
        </div>
        <div>
        <label>{texts.lastName}</label>
        <input placeholder={texts.lastName} className="bg-gray-900 w-full px-4 py-2 mt-1 rounded" />
        </div>
      <div>
      <label>{texts.emailAddress}</label>
      <input placeholder={texts.emailAddress} className="bg-gray-900 w-full px-4 py-2  mt-1 rounded" autoComplete='off' />
      </div>
      <div className="flex justify-end space-x-2 mt-4">
      <button className="border border-gray-500 text-white px-4 ms-2 py-2 rounded">{texts.cancel}</button>
      <button className="bg-[#5A189A] px-4 py-2 rounded text-white">{texts.save}</button>
    </div>
    </div>
  </div>

  
  <div className="bg-gray-800 shadow-xl rounded p-6 text-white">
    <h2 className="text-lg font-semibold mb-4 border-b border-gray-600 pb-4">{texts.updatePassword}</h2>
    <div className="space-y-4">
        <div>
            <label>{texts.currentPassword}</label>
        <input
        placeholder={texts.currentPassword}
        type="password"
        className="bg-gray-900 w-full px-4 py-2 rounded mt-1"
      />
        </div>
      <div>
        <label>{texts.newPassword}</label>
        <input
        placeholder={texts.newPassword}
        type="password"
        className="bg-gray-900 w-full px-4 py-2 rounded mt-1"
      />
      </div>
      <div>
        <label>{texts.confirmNewPassword}</label>
      </div>
      <input
        placeholder={texts.confirmNewPassword}
        type="password"
        className="bg-gray-900 w-full px-4 py-2 rounded mt-1"
      />
    </div>
    <div className="flex justify-end space-x-2 mt-4">
      <button className="border border-gray-500 text-white px-4 ms-2 py-2 rounded">{texts.cancel}</button>
      <button className="bg-[#5A189A] px-4 py-2 rounded text-white">{texts.save}</button>
    </div>
  </div>


  <div className="md:col-span-2 bg-gray-800 shadow-xl rounded p-6 text-white">
    <h2 className="text-lg font-semibold mb-4">{texts.yourPhoto}</h2>
    <div className="flex items-center space-x-4 mb-4">
      <img src="/images/bg-images/user-profile.jpg" alt="Profile" className="w-16 h-16 rounded-full bg-white object-cover" />
      <div>
        <p className='pb-0 mb-0'>{texts.editYourPhoto}</p>
        <div className="text-sm text-gray-400 space-x-2">
          <button className="no-underline text-red-500">{texts.delete}</button>
          <button className="no-underline text-green-500">{texts.update}</button>
        </div>
      </div>
    </div>
    <div className="border-dashed border-1 border-gray-500 rounded-lg p-8 flex flex-col items-center justify-center text-center cursor-pointer hover:border-[#5A189A] transition duration-300">
  <label htmlFor="profilePhoto" className="flex flex-col items-center space-y-2 w-full cursor-pointer">
   
    <div className="bg-gray-700 p-3 rounded-full text-[#5A189A]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1M16 12l-4-4m0 0l-4 4m4-4v8"
        />
      </svg>
    </div>

   
    <input
      id="profilePhoto"
      name="profile"
      type="file"
      accept="image/png, image/jpg, image/jpeg, image/gif"
      className="hidden"
    />

   
    <p className="mb-0 pb-0">{texts.uploadInstructions}</p>
    
    <p className="text-sm text-gray-400">SVG, PNG, JPG or GIF (max, 800 x 800px)</p>
  </label>
</div>

    <div className="flex justify-end space-x-2 mt-4">
    
      <button className="border border-gray-500 text-white px-4 py-2 ms-2 rounded">{texts.cancel}</button>
      <button className="bg-[#5A189A] px-4 py-2 rounded text-white">{texts.save}</button>
    </div>
  </div>
 </div>

      </div> 
      */}
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="min-h-screen w-full px-4 py-4 text-white">
            <section className="pt-1 grid grid-cols-2 items-center ">
              <h1 className="text-xl font-bold text-white">
                {translations.profile.settings}
              </h1>
              <div className="text-md text-white flex items-center justify-end space-x-1 ">
                <div className="rounded-full bg-[#5A189A] py-2 px-3">
                  <Link
                    to="/"
                    className="text-white no-underline cursor-pointer"
                  >
                    {translations.profile.dashboard}
                  </Link>
                  <span className="mx-1">/</span>
                  <span className="text-green-300">
                    {translations.profile.settings}
                  </span>
                </div>
              </div>
            </section>
            <div className=" bg-gray-800 rounded-xl shadow-lg p-6 space-y-8  mt-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Left Side: Personal Information */}
                <div className="border-r border-gray-600 pe-4">
                  <h2 className="text-lg font-semibold mb-4  pb-4">
                    {translations.profile.personalInformation}
                  </h2>
                  <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
                    <div>
                      <label>{translations.profile.firstName}</label>
                      <input
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        placeholder={translations.profile.firstName}
                        className="bg-gray-900 w-full px-4 py-2 mt-1 rounded"
                      />
                    </div>
                    <div>
                      <label>{translations.profile.emailAddress}</label>
                      <input
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder={translations.profile.emailAddress}
                        className="bg-gray-900 w-full px-4 py-2 mt-1 rounded"
                      />
                    </div>
                    <div>
                      <label className="block text-sm text-white mb-1">
                        {translations.profile.phoneNumber}
                      </label>
                      <input
                        value={phoneNumber}
                        onChange={(e) => {
                          setPhoneNumber(e.target.value);
                          if (!e.target.value.trim().startsWith("+")) {
                            setError("Country code is mandatory.");
                          } else {
                            setError("");
                          }
                        }}
                        placeholder="Enter your phone number with country code"
                        className="bg-gray-900 w-full px-4 py-2 mt-1 rounded text-white"
                      />
                      {error && (
                        <p className="text-red-500 text-sm mt-1">{error}</p>
                      )}
                    </div>
                  </div>
                  <div className="flex justify-end rtl:justify-start rtl:space-x-reverse space-x-2 mt-4">
                    <button className="border border-gray-500 text-white px-4 py-2 rounded">
                      {translations.profile.cancel}
                    </button>
                    <button
                      className="bg-[#5A189A] px-4 py-2 rounded text-white"
                      onClick={onSubmit}
                    >
                      {translations.profile.save}
                    </button>
                  </div>
                </div>

                {/* Right Side: Update Password */}
                <div className="mb-3">
                  <h2 className="text-lg font-semibold mb-4 pb-4">
                    {translations.profile.updatePassword}
                  </h2>
                  <div className="grid grid-cols-1 gap-4">
                    <div>
                      <label>{translations.profile.currentPassword}</label>
                      <input
                        type="password"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        placeholder={translations.profile.currentPassword}
                        className="bg-gray-900 w-full px-4 py-2 rounded mt-1"
                      />
                    </div>
                    <div>
                      <label>{translations.profile.newPassword}</label>
                      <input
                        type="password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        placeholder={translations.profile.newPassword}
                        className="bg-gray-900 w-full px-4 py-2 rounded mt-1"
                      />
                    </div>
                    <div>
                      <label>{translations.profile.confirmNewPassword}</label>
                      <input
                        type="password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        placeholder={translations.profile.confirmNewPassword}
                        className="bg-gray-900 w-full px-4 py-2 rounded mt-1"
                      />
                    </div>
                  </div>
                  <div className="flex justify-end rtl:justify-start rtl:space-x-reverse space-x-2 mt-4">
                    <button className="border border-gray-500 text-white px-4 py-2 rounded">
                      {translations.profile.cancel}
                    </button>
                    <button
                      className="bg-[#5A189A] px-4 py-2 rounded text-white"
                      onClick={handlePasswordUpdate}
                    >
                      {translations.profile.save}
                    </button>
                  </div>
                </div>
              </div>

              {/* <div className="md:col-span-2   p-6 text-white  ">
    <h2 className="text-lg font-semibold mb-4 border-b border-gray-600 pb-4">{texts.yourPhoto}</h2>
    <div className="flex items-center space-x-4 mb-4">
      <img src="/images/bg-images/user-profile.jpg" alt="Profile" className="w-16 h-16 rounded-full bg-white object-cover" />
      <div>
        <p className='pb-0 mb-0'>{texts.editYourPhoto}</p>
        <div className="text-sm text-gray-400 space-x-2">
          <button className="no-underline text-red-500">{texts.delete}</button>
          <button className="no-underline text-green-500">{texts.update}</button>
        </div>
      </div>
    </div>
    <div className="border-dashed border-1 border-gray-500 rounded-lg p-8 flex flex-col items-center justify-center text-center cursor-pointer hover:border-[#5A189A] transition duration-300">
  <label htmlFor="profilePhoto" className="flex flex-col items-center space-y-2 w-full cursor-pointer">
    Upload Icon
    <div className="bg-gray-700 p-3 rounded-full text-[#5A189A]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1M16 12l-4-4m0 0l-4 4m4-4v8"
        />
      </svg>
    </div>

    File Input
    <input
      id="profilePhoto"
      name="profile"
      type="file"
      accept="image/png, image/jpg, image/jpeg, image/gif"
      className="hidden"
    />

    Upload Text
    <p className="mb-0 pb-0">{texts.uploadInstructions}</p>
    <p className="text-green-500 font-medium">{texts.clickToUpload}</p>
    <p className="text-sm text-gray-400">SVG, PNG, JPG or GIF (max, 800 x 800px)</p>
  </label>
</div>

    <div className="flex justify-end space-x-2 mt-4">
    
      <button className="border border-gray-500 text-white px-4 py-2 ms-2 rounded">{texts.cancel}</button>
      <button className="bg-[#5A189A] px-4 py-2 rounded text-white">{texts.save}</button>
    </div>
  </div> */}
            </div>
          </div>
        </>
      )}
    </Layout>
  );
}

export default AdminProfile;
